import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../App'
import { useNavigate } from 'react-router-dom'
import { LoadingFull } from '../../components/loading';
import axios from 'axios';
import { Payout } from '../../components/dashboard/saldo/payout';
import Overview from '../../components/dashboard/saldo/overview';
import Transactions from '../../components/dashboard/saldo/transactions';
import { SuccessPayout } from '../../components/dashboard/alert';

export default function Saldo() {

  const [isLoaded, setIsLoaded] = useState(false)
  const [stripeUser, setStripeUser] = useState()
  const navigate = useNavigate()
  const { user } = useContext(UserContext)
  const token = localStorage.getItem('token')
  
  useEffect(() => {
    axios({
        method: 'post',
        url: '/api/stripeUser',
        data: {
            'stripeId': user.stripeId,
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
    })
    .then(response => {
      setStripeUser(response.data)
    })
    .catch(error => {
      console.log(error);
    });
  }, [])

  return (
    <div className="flex flex-col gap-5">
      {(typeof stripeUser !== 'undefined' && 'payout' in stripeUser) ?
        <SuccessPayout amount={stripeUser.payout} />
      :
        ""}
      <div className="h-full relative flex flex-col lg:flex-row gap-5">
        <Overview stripeUser={stripeUser} setStripeUser={setStripeUser} />
        <Payout returnUrl={window.location.href} stripeUser={stripeUser} />
      </div>
      <Transactions stripeUser={stripeUser} />
    </div>
  )
}